// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
    margin: 0;
}
.grid {
    grid-auto-columns: repeat(4, auto);
  }
.grid.screenings {
    grid-template-columns: repeat(10, auto);
}

.holder {
    background: #efeff7;
}

form {
    background-color: #efeff7;
}

.input-fields {
    padding-left: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/packages-module/packages-view/packages-view.component.css"],"names":[],"mappings":"AAAA;IACI,SAAS;AACb;AACA;IACI,kCAAkC;EACpC;AACF;IACI,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":["h1 {\r\n    margin: 0;\r\n}\r\n.grid {\r\n    grid-auto-columns: repeat(4, auto);\r\n  }\r\n.grid.screenings {\r\n    grid-template-columns: repeat(10, auto);\r\n}\r\n\r\n.holder {\r\n    background: #efeff7;\r\n}\r\n\r\nform {\r\n    background-color: #efeff7;\r\n}\r\n\r\n.input-fields {\r\n    padding-left: 15px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
